export default "__VITE_ASSET__BcKShsI1__"